<template>
  <div>
    <ith-grid-skeleton v-show="movies == null" :items="24" />

    <div v-show="movies == ''">
      <ith-no-results :text="no_result" />
    </div>
    <div class="movie">
      <div
        v-for="item in movies"
        :key="item.id"
        class="movie--item"
        @click="goToShow(item)"
      >
        <router-link :to="`/detail/${item.id}/${item.slug}`">
          <figure class="movie-img">
            <div v-lazy-container="{ selector: 'img' }">
              <img
                v-if="item.imageUrl != null && item.imageUrl != ''"
                class="movie-img"
                :data-src="item.imageUrl"
              />
              <img v-else class="movie-no-img" data-src="/img/no_image.png" />
            </div>
          </figure>
          <span class="movie-overlay">
            <p><font-awesome-icon color="#ffffff" icon="plus" /> Details</p>
            <p>
              <font-awesome-icon color="#ffffff" icon="star" />
              <span class="rating" v-if="item.rating"> {{ item.rating }} </span>
              <span class="rating" v-else> N/A</span>
            </p>
            <div class="imdb--area">
              <img
                class="icon--imdb"
                src="../../assets/imdb.png"
                alt="IMBD logo"
              />
              <span class="text--imdb" v-if="item.imdbRating">
                {{ item.imdbRating }}</span
              >
              <span class="text--imdb" v-else> N/A</span>
            </div>
            <p>
              <span v-show="item.watchlist"
                ><font-awesome-icon color="#ffffff" icon="check" /> Watchlist
              </span>
              <span v-show="!item.watchlist" style="color: #939292"
                ><font-awesome-icon icon="plus-circle" /> Watchlist</span
              >
            </p>
            <p>
              <span v-show="item.watched"
                ><font-awesome-icon color="#ffffff" icon="eye" /> Watched
              </span>
              <span v-show="!item.watched" style="color: #939292"
                ><font-awesome-icon icon="eye" /> Watched</span
              >
            </p>
            <span
              class="platform"
              v-if="item.platforms && item.platforms.length"
              >{{ item.platforms[0].platform | uppercase }}</span
            >
          </span>
        </router-link>
      </div>
    </div>
    <ith-pagination-bullets
      :items="totalPagesMovies"
      :pagination="paramsMovies.page"
      :k="key"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["movies", "paramsMovies", "totalPagesMovies"]),
  data: () => ({
    key: "movies",
    no_result: `<p>We’ve searched hundreds of TV shows and</p>
      <p>we did not found any title for your search.</p>`,
  }),

  methods: {
    goToShow(item) {
      this.$store.commit("EDIT_SHOW", item);
    },
  },
};
</script>

<style scoped>
.loading {
  font-size: 2em;
  color: #7797c2;
  position: absolute;
  left: 50%;
}

.movie {
  display: grid;
  grid-template-columns: repeat(8, auto);
  justify-content: space-between;
  column-gap: 15px;
}
.movie--item {
  margin-top: 20px;
  width: 130px;
  height: 187px;
  background-color: #d5d5d5;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  display: block;
}
.movie-img {
  margin: 0;
  border-radius: 10px;
  width: 130px;
  height: 187px;
  object-fit: cover;
}
.movie-no-img {
  margin: 0;
  border-radius: 10px;
  width: 70%;
  object-fit: contain;
  margin: 20% 15%;
}
.movie-overlay {
  font-size: 0.75rem;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: none;
  border: 3px solid #ff5f5f;
  align-items: center;
  justify-content: center;
  color: white;
}

.movie-overlay > p {
  margin-top: 2px;
  text-align: center;
}

.movie--item:hover .movie-overlay {
  display: flex;
  flex-direction: column;
}
.platform {
  border-radius: 0px 0px 7px 7px;
  position: absolute;
  width: 100%;
  padding: 2px 2px 3px 2px;
  bottom: 0px;
  border: 1px solid #ff5f5f;
  background: #ff5f5f;
  text-align: center;
  overflow: hidden;
}
.icon--imdb {
  width: 27px;
}

.imdb--area {
  display: flex;
  align-items: center;
  padding-bottom: 7px;
}
.text--imdb {
  margin-left: 5px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .movie {
    grid-template-columns: repeat(6, auto);
    column-gap: 12px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .movie {
    grid-template-columns: repeat(5, auto);
    column-gap: 15px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .movie {
    grid-template-columns: repeat(4, auto);
    justify-content: space-evenly;
    column-gap: 15px;
  }
}

@media (max-width: 600px) {
  .movie {
    grid-template-columns: repeat(2, auto);
    column-gap: 15px;
    justify-content: space-evenly;
  }
}
</style>
